//import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService, UserTypes, SMSEntity } from 'src/app/Shared/Common/common.service';
import { PropertyPostsService } from 'src/app/Shared/PostRequests/property-posts.service';
import { UsersService } from 'src/app/Shared/Users/users.service';
// import { WebcamImage, WebcamInitError } from 'ngx-webcam';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { HttpClient } from '@angular/common/http';

declare var $: any;

@Component({
  selector: 'app-agents-login',
  templateUrl: './agents-login.component.html',
  styleUrls: ['./agents-login.component.css']
})
export class AgentsLoginComponent implements OnInit {

  @Input() PortalType: string = 'Mobile';
  isLoader: boolean = false;
  otpTemplate: SMSEntity;
  userType: string = '';
  userTypeID: number;
  userName: string = '';
  userOldName: string = '';
  UserData: any[] = [];
  isOTP: boolean = false;
  userotp: number;
  UserOTPData: number;
  isPIN: boolean = false;
  userPIN: string = '';
  isUserPin: boolean = false;
  currentPinIndex: number = 0;
  enteredPin: string[] = ['', '', '', ''];
  isAgent: boolean = false;
  areasList: any[] = [];
  selectedCitiesList: any[] = [];
  addAgentModel: any = {
    UserName: '',
    Password: '',
    UserTypeID: null,
    CompanyName: '',
    // AgentLogo: '',
    // AgentPhoto: '',
    CitiesOfOperation: '',
    ReferralCode: '',
  };
  arrList: any[] = [];
  isForgotPIN: boolean = false;
  forgotPINData: number;
  isButtonClicked = false;
  userForm: FormGroup;
  isLoginWithOtp: boolean = false;

  // Add these variables
  // public showWebcam = true;
  // public allowCameraSwitch = true;
  // public multipleWebcamsAvailable = false;
  public deviceId: string;
  // public webcamImage: WebcamImage = null;
  // public errors: WebcamInitError[] = [];

  // @ViewChild('fileInput') fileInput: ElementRef;

  // publicIP: string;
  // private apiUrl: string = 'https://api.ipify.org?format=json';


  constructor(private loginRouter: Router, private loginRoute: ActivatedRoute, private loginCommon: CommonService
    , private loginUsersService: UsersService, private postPropertyPostsService: PropertyPostsService, private fb: FormBuilder, private http: HttpClient) { }

  ngOnInit() {
    this.userForm = this.fb.group({
      userName: ['', [
        Validators.required,
        Validators.pattern(/^\d{0,10}$/) // Allows up to 10 digits
      ]]
    });
    this.userTypeID = UserTypes.Agent;
    this.isLoginWithOtp = false;
    this.LoadAreasByCity();
    //this.getPublicIP();
  }

  // getPublicIP(): void {
  //   this.http.get<any>(this.apiUrl).subscribe(
  //     data => {
  //       this.publicIP = data.ip;
  //       console.log(this.publicIP);
  //     },
  //     error => {
  //       console.error('Error fetching public IP', error);
  //     }
  //   );
  // }

  LoadAreasByCity() {
    try {
      this.isLoader = true;
      this.postPropertyPostsService.GetAllAreasByType(601).subscribe(res => {
        this.isLoader = false;
        if (res.status == 1) {
          this.areasList = res.body;
        }
      }, err => {
        this.isLoader = false;
      });
    } catch (error) {
      this.isLoader = false;
    }
  }

  doUserLogin() {
    const userNameControl = this.userForm.get('userName');
    if (userNameControl.errors?.pattern || userNameControl.value === '') {
      this.loginCommon.CallToster('W', 'Please enter valid 10 digits Mobile number');
      return;
    } else {
      let _mobExp = /^([6-9]{1})([0123456789]{1})([0-9]{8})$/;
      if (!_mobExp.test(userNameControl.value)) {
        this.loginCommon.CallToster('W', 'Please enter valid 10 digits Mobile number');
        return;
      } else {
        if (this.isLoginWithOtp == true) {
          this.ValidateLoginWithOTP();
        }
        else if (this.userOldName !== userNameControl.value) {
          this.checkUserMobile();
        } else if (this.isPIN) {
          this.doCheckUserAuthencations();
        } else if (!this.isOTP) {
          this.checkUserMobile();
        } else {
          this.CheckMobileOTP();
        }
      }
    }
  }

  checkUserMobile() {
    try {
      this.isLoader = true;
      this.currentPinIndex = 0;
      this.enteredPin = ['', '', '', ''];
      this.isPIN = false;
      this.isOTP = false;
      this.userPIN = '';
      this.isUserPin = false;
      this.loginUsersService.CheckUserByMobile(this.userForm.get('userName').value).subscribe(res => {
        this.isLoader = false;

        if (res.status == 1) {
          this.userOldName = this.userForm.get('userName').value;
          this.userName = this.userForm.get('userName').value;
          this.UserData = res.body;
          if (this.UserData.length == 0) {
            $('#ConfirmModal').modal({ backdrop: 'static', keyboard: false });
            setTimeout(() => {
              $('.modal-backdrop').css("display", "none");
            }, 500);
          }
          else {
            if (this.UserData[0].IsAgent == true) {
              if (this.UserData[0].IsAgentActive == false) {
                this.isLoader = false;
                this.isPIN = false;
                this.loginCommon.CallToster('E', 'Your account is currently being verified due to recent modifications..!');
                return;
              }
              else {
                this.isPIN = true;
                setTimeout(() => {
                  $('#userPIN').focus();
                }, 100);
              }
            }
            else {
              $('#UserAlreadyExitsModal').modal({ backdrop: 'static', keyboard: false });
              setTimeout(() => {
                $('.modal-backdrop').css("display", "none");
              }, 500);
            }
          }
        }
        else {
          this.isLoader = false;
          this.isPIN = false;
          this.loginCommon.CallToster('E', res.errorMessage);
        }
      }, err => {
        this.isLoader = false;
        this.isPIN = false;
        this.loginCommon.CallToster('E', 'Something went wrong while validate mobile number, Please try again later...!');
      });
    } catch (error) {
      this.isLoader = false;
      this.isPIN = false;
      this.loginCommon.CallToster('E', 'Unable to validate mobile number, Please try again later...!');
    }
  }

  doCheckUserAuthencations() {
    try {
      this.enteredPin = ['', '', '', ''];
      let user = {
        Mobile: this.userForm.get('userName').value,
        Password: this.userPIN.trim()
      }
      this.isLoader = true;
      let authData = [];
      this.loginUsersService.UserAuthencations(user).subscribe(res => {
        this.isLoader = false;
        if (res.status == 1) {
          authData = res.body;
          if (authData.length == 0) {
            this.loginCommon.CallToster('E', 'Invalid Mobile number or PIN, Please try again...!');
          }
          else {
            let userData = {
              UserID: authData[0].UserID,
              UserName: authData[0].UserID,
              UserType: this.userTypeID,
              IsVisitor: false,
              IsAgent: true,
              IsBuilder: false
            }
            this.doGetUserDetails(authData[0].UserID, JSON.stringify(userData))
          }
        }
        else {
          this.loginCommon.CallToster('E', 'Something went wrong while authencate you details, Please try again later...!');
        }
      });
    } catch (error) {
      this.isLoader = false;
      this.loginCommon.CallToster('E', 'Unable to authencate you details, Please try again later...!');
    }
  }

  doGetUserDetails(userId: number, userLog: string) {
    try {
      this.isLoader = true;
      this.loginUsersService.GetUserProfile(userId, this.userTypeID).subscribe((res) => {
        this.isLoader = false;
        if (res.status === 1) {
          const userData = res.body[0];

          // Clear existing session storage
          localStorage.removeItem('authData');
          localStorage.removeItem('authProfileData');
          localStorage.removeItem('authExpiry'); // Remove old expiry time

          // Set the new data and expiry time (60 minutes)
          const expiryTime = new Date().getTime() + 60 * 60 * 1000; // 60 minutes in milliseconds

          // Save new user data and expiry to local storage
          localStorage.setItem('authData', userLog);
          localStorage.setItem('authProfileData', JSON.stringify(userData));
          localStorage.setItem('authExpiry', expiryTime.toString());

          // Check if the user is a guest
          if (userData.UserName.toLowerCase() === 'guest') {
            if (this.PortalType == 'Mobile')
              this.loginRouter.navigate(['/m/myprofile']);
            else
              this.loginRouter.navigate(['/myprofile']);
          } else {
            const postProperty = sessionStorage.getItem('PostProperty');

            if (postProperty === '1') {
              // Optionally reset the session storage value after use
              sessionStorage.removeItem('PostProperty');
              if (this.PortalType == 'Mobile')
                this.loginRouter.navigate(['/m/post-request']);
              else
                this.loginRouter.navigate(['/post-request']);
            } else {
              if (this.PortalType == 'Mobile')
                this.loginRouter.navigate(['/m/searchproperty']);
              else
                this.loginRouter.navigate(['/searchproperty']);
            }
          }
        } else {
          this.isLoader = false;
          this.loginCommon.CallToster('E', 'Unable to authenticate your details, Please try again later...!');
        }
      }, (err) => {
        this.isLoader = false;
        this.loginCommon.CallToster('E', 'Unable to authenticate your details, Please try again later...!');
      });
    } catch (error) {
      this.isLoader = false;
      this.loginCommon.CallToster('E', 'Unable to authenticate your details, Please try again later...!');
    }
  }

  // Function to check if localStorage data has expired
  checkAuthExpiry() {
    const expiryTime = localStorage.getItem('authExpiry');
    if (expiryTime) {
      const now = new Date().getTime();
      if (now > parseInt(expiryTime)) {
        // Clear expired data
        localStorage.removeItem('authData');
        localStorage.removeItem('authProfileData');
        localStorage.removeItem('authExpiry');
        // Optionally, you can redirect the user to login again
        if (this.PortalType == 'Mobile')
          this.loginRouter.navigate(['/login']);
        else
          this.loginRouter.navigate(['/']);
      }
    }
  }


  CheckMobileOTP() {
    ////console.log(this.userotp + ' | ' + this.UserOTPData);
    ////console.log(this.isUserPin);
    if (this.userotp == null) {
      this.loginCommon.CallToster('E', 'Please enter OTP...!');
      return;
    }
    if (this.userotp == this.UserOTPData) {
      if (this.isUserPin == false) {
        this.enteredPin = ['', '', '', ''];
        this.EnablePINModel();
      }
      else
        this.doSubmitUserData();
    }
    else {
      this.loginCommon.CallToster('E', 'Invalid OTP, Please try again later...!');
    }
  }

  EnablePINModel() {
    if (this.userTypeID == UserTypes.Visitor && this.UserData.length == 0)
      this.isUserPin = true;
    else {
      this.ValidateAgentInfo();
    }
  }

  ValidateAgentInfo() {
    if (this.addAgentModel.CompanyName == '') {
      this.loginCommon.CallToster('E', 'Please enter company name...!');
      return;
    }
    else if (this.selectedCitiesList.length == 0) {
      this.loginCommon.CallToster('E', 'Please enter cities name to operate...!');
      return;
    }
    // else if (this.addAgentModel.AgentLogo == '') {
    //   this.loginCommon.CallToster('E', 'Please select company logo...!');
    //   return;
    // }
    // else if (this.addAgentModel.AgentLogo == '') {
    //   this.loginCommon.CallToster('E', 'Please select ID Proof...!');
    //   return;
    // }
    else {
      if (this.userTypeID == UserTypes.Agent && this.UserData.length != 0) {
        this.doAddAgent();
      }
      else
        this.isUserPin = true; //$('#UserOTPModal').modal({ backdrop: 'static', keyboard: false });
    }
  }


  doSubmitUserData() {
    ////console.log(this.enteredPin.length);
    if (this.enteredPin[3] == '') {
      this.loginCommon.CallToster('E', 'Please enter pin...!');
      return;
    }
    this.userPIN = '';
    this.enteredPin.forEach(element => {
      this.userPIN += element;
    });
    this.doAddAgent();
  }

  doAddAgent() {
    try {
      this.addAgentModel.CitiesOfOperation = this.selectedCitiesList + ',';
      this.addAgentModel.UserName = this.userForm.get('userName').value;
      this.addAgentModel.Password = this.userPIN.trim();
      this.addAgentModel.UserTypeID = this.userTypeID;
      this.addAgentModel.ReferralCode = localStorage.getItem('referralCode') ? localStorage.getItem('referralCode') : null // Assign only if available
      ////console.log(this.addAgentModel);
      this.isLoader = true;
      //this.addAgentModel.CitiesOfOperation.substring(0, this.addAgentModel.CitiesOfOperation.length - 1)
      this.loginUsersService.SaveAgentData(this.addAgentModel).subscribe((res) => {
        this.isLoader = false;
        if (res.status == 1) {
          if (res.body[0].USERID != 0) {
            this.loginCommon.DismissModel();
            this.SendWelcomeNoteWhats();
            // this.loginCommon.CallToster('S', 'Congratulations! Your agent registration was successful.');
            // setTimeout(() => {
            //   this.loginRouter.navigate(['/m']);
            // }, 1000);

            this.doCheckUserAuthencations();

            //************************** */
            // this.SendWelcomeNoteWhats();
            // this.loginCommon.CallToster('S', 'Successfully submitted data and our backend team will contact you soon...!');
            // setTimeout(() => {
            //   this.loginRouter.navigate(['/m']);
            // }, 1000);
          }
          else {
            this.loginCommon.CallToster('E', 'Error in while Login, Please try again later...!');
          }
        }
        else {
          this.loginCommon.CallToster('E', 'Error in while save your details, Please try again later...!');
        }
      }, err => {
        this.isLoader = false;
        this.loginCommon.CallToster('E', 'Something went wrong while register your details, Please try again later...!');
      });
    } catch (error) {
      //console.log(error);
      this.loginCommon.CallToster('E', 'Unable to register you details, Please try again later...!');
    }
  }

  SendOTPByMobile() {
    try {
      // Check if the button has already been clicked
      if (this.isButtonClicked) {
        return;
      }

      // Set the buttonClicked flag to true to indicate the button has been clicked
      this.isButtonClicked = true;

      this.currentPinIndex = 0;

      setTimeout(() => {
        $('#UserAlreadyExitsModal').modal('hide');
        $('#ConfirmModal').modal('hide');
      }, 1000);

      this.isLoader = true;

      // Generate a random OTP
      this.UserOTPData = Math.floor(100000 + Math.random() * 900000);

      this.isOTP = true;
      this.SendOTPSMS();
      this.SendWhatsAppMsg();  // Commented by Rama
      this.loginCommon.CallToster('S', 'An OTP has been sent to the provided mobile. Please check and enter...!');

      if (this.userTypeID == UserTypes.Agent) {
        this.isAgent = true;
        setTimeout(() => {
          $('#ddlPreferredAreas').selectpicker();
        }, 2000);
      }

      // Simulate an asynchronous operation with a timeout
      setTimeout(() => {
        // ... other asynchronous tasks

        // Hide the modals
        $('#UserAlreadyExitsModal').modal('hide');
        $('#ConfirmModal').modal('hide');
        this.isLoader = false;
        this.isButtonClicked = false; // Reset the button state
      }, 1000);
    } catch (error) {
      //console.log(error);
      this.isLoader = false;
      this.isOTP = false;
      this.userotp = null;
      this.loginCommon.CallToster('E', 'Unable to validate mobile number. Please try again later...!');
      this.isButtonClicked = false; // Reset the button state in case of an error
    }
  }

  SendOTPSMS(isWatsapp: boolean = false, isForgot: boolean = false) {
    try {
      this.isLoader = true;
      let Text = '';
      if (isWatsapp == true)
        this.SendWhatsAppMsg();

      if (isForgot == true)
        Text = "" + this.forgotPINData + " is your verification OTP for Buyrentsale.com. Please do not share this code with anyone. - AINEXT IT";
      else
        Text = "" + this.UserOTPData + " is your verification OTP for Buyrentsale.com. Please do not share this code with anyone. - AINEXT IT";

      this.loginCommon.SendSMS(Text, this.userForm.get('userName').value).subscribe(res => {
        this.isLoader = false;
        //console.log(res);
      }, err => {
        this.isLoader = false;
        //console.log(err);
      });
    } catch (error) {
      this.isLoader = false;
      //console.log(error);
    }
  }

  //Created by Rama
  SendWhatsAppMsg(isForgot: boolean = false) {
    try {
      let msg = '';
      if (isForgot == true)
        msg = "" + this.forgotPINData + " is your verification OTP for Buyrentsale.com. Please do not share this code with anyone. \n\nTeam,\nBuyrentsale.com\nMobile: 9618641100\nEmail: support @buyrentsale.com"; // Replace with the actual message
      else
        msg = "" + this.UserOTPData + " is your verification OTP for Buyrentsale.com. Please do not share this code with anyone. \n\nTeam,\nBuyrentsale.com\nMobile: 9618641100\nEmail: support @buyrentsale.com"; // Replace with the actual message

      this.loginCommon.postMsgWithUrlToWhatsapp(this.userForm.get('userName').value, msg).subscribe(res => {
        this.isLoader = false;
        //console.log('POST request sent successfully.');
        console.log('Response Content: ', res);
      }, err => {
        this.isLoader = false;
        //console.error('Error:', err);
      });

    } catch (error) {
      this.isLoader = false;
      //console.error('Error:', error);
      //console.log(error);
    }
  }

  //Created by Rama
  SendWelcomeNoteWhats() {
    try {
      let msg = "Welcome to BuyRentSale.com, India's first real estate network and advertisement platform, "
      msg += "revolutionizing the property landscape by connecting buyers, sellers, agents, builders, and real estate business partners. "
      msg += "We provide a dynamic hub where property aspirations meet unparalleled opportunities. Join us to collectively fulfill everyone's dream of owning a property"
      msg += ".\n\n Experience BuyRentsale.com through this Product Demo Video Link : https://www.youtube.com/watch?v=adEo19mS2c4\n\nMore details and step-by-step guide on BuyRentsale.com "
      msg += "PDF Link : https://api.buyrentsale.com/uploads/defaults/buyrentsale.pdf \n\nTeam,\nBuyrentsale.com\nMobile:9618641100\nEmail: support@buyrentsale.com";

      this.loginCommon.postMsgWithUrlToWhatsapp(this.userForm.get('userName').value, msg).subscribe(res => {
        this.isLoader = false;
        //console.log('POST request sent successfully.');
        //console.log('Response Content: ', res);
      }, err => {
        this.isLoader = false;
        //console.error('Error:', err);
      });

    } catch (error) {
      this.isLoader = false;
      //console.error('Error:', error);
      //console.log(error);
    }
  }

  ForgotPassword() {
    try {
      this.isLoader = true;
      this.forgotPINData = Math.floor(100000 + Math.random() * 900000);

      this.SendOTPSMS(false, true);
      this.SendWhatsAppMsg(true);  // Created by Rama
      this.isForgotPIN = true;

      this.loginCommon.CallToster('S', 'An OTP has been sent to the provided mobile. Please check and enter...!');

      this.isLoader = false;
    } catch (error) {
      //console.log(error);
      this.isLoader = false;
      this.isForgotPIN = false;
      this.loginCommon.CallToster('E', 'Unable to validate mobile number, Please try again later...!');
    }
  }


  doChangeUserPassword() {
    try {
      if (this.userotp == undefined) {
        this.isUserPin = false;
        this.loginCommon.CallToster('E', 'Please enter OTP...!');
        return;
      }
      else {
        if (this.userotp == this.forgotPINData) {
          if (this.isUserPin) {
            if (this.enteredPin[3] == '') {
              this.loginCommon.CallToster('E', 'Please enter pin...!');
              return;
            }
            else {
              this.userPIN = ''; 
              this.enteredPin.forEach(element => {
                this.userPIN += element;
              });
              this.isLoader = true;
              this.loginUsersService.SaveUserPassword(this.UserData[0].UserID, this.userPIN.trim()).subscribe(res => {
                this.isLoader = false;
                if (res.status == 1) {
                  this.enteredPin = ['', '', '', ''];
                  this.ResetToLogin();
                  this.loginCommon.CallToster('S', 'Successfully PIN changed, Please Login...!');
                }
                else {
                  this.isLoader = false;
                  this.loginCommon.CallToster('E', res.errorMessage);
                }
              }, err => {
                this.isLoader = false;
                this.loginCommon.CallToster('E', 'Something went wrong while change PIN, Please try again later...!');
              });
            }
          } else {
            this.isUserPin = true;
          }
        }
        else {
          this.isUserPin = false;
          this.loginCommon.CallToster('E', 'Invalid OTP...!');
          return;
        }
      }
    } catch (error) {
      this.isLoader = false;
      this.loginCommon.CallToster('E', 'Unable to change PIN, Please try again later...!');
    }
  }

  AddPINintoArray(pinType: string) {
    if (pinType == 'C') {
      this.currentPinIndex = 0;
      this.enteredPin = ['', '', '', ''];
    }
    else if (pinType == 'B') {
      if (this.currentPinIndex != 0) {
        this.currentPinIndex -= 1;
        this.enteredPin[this.currentPinIndex] = '';
      }
    }
    else {
      if (this.currentPinIndex < 4) {
        this.enteredPin[this.currentPinIndex] = pinType;
        this.currentPinIndex += 1;
      }
    }
  }

  doLoginWithOTP() {
    try {
      if (this.isButtonClicked) {
        return;
      }
      this.isButtonClicked = true;
      this.isLoginWithOtp = true;
      this.isPIN = false;
      this.isLoader = true;
      this.UserOTPData = Math.floor(100000 + Math.random() * 900000);
      //console.log(this.UserOTPData);
      this.SendOTPSMS();
      this.SendWhatsAppMsg();
      this.loginCommon.CallToster('S', 'An OTP has been sent to the provided mobile. Please check and enter it.');
      this.isLoader = false;
      setTimeout(() => {
        this.isButtonClicked = false; // Reset the button state
      }, 10000);
    } catch (error) {
      this.isLoader = false;
      this.userotp = null;
      this.loginCommon.CallToster('E', 'Unable to validate Mobile number, Please try again later...!');
      this.isButtonClicked = false; // Reset the button state in case of an error
    }
  }

  ValidateLoginWithOTP() {
    try {
      if (this.userotp == this.UserOTPData) {
        this.userPIN = this.UserData[0].User_Password;
        this.doCheckUserAuthencations();
      }
      else {
        this.loginCommon.CallToster('E', 'Invalid OTP, Please try again later...!');
        return;
      }
    } catch (error) {
      this.loginCommon.CallToster('E', 'Unable to validate OTP, Please try again later...!');
      return;
    }
  }

  // OpenImageDailogBox(imgType: string) {
  //   if (imgType == 'C')
  //     $('#agentLogo').trigger('click');
  //   else if (imgType == 'I')
  //     $('#agentPhoto').trigger('click');
  // }

  // agentLogo_change(event: any): void {
  //   try {
  //     var ext = $('#agentLogo').val().split('.').pop().toLowerCase();
  //     if ($.inArray(ext, ['gif', 'png', 'jpg', 'jpeg']) == -1) {
  //       this.loginCommon.CallToster('E', 'Invalid image format, Please upload image only...!');
  //       $('#agentLogo').val('');
  //     } else {
  //       var imageToUpload = event.target.files[0];

  //       // Check image dimensions
  //       const img = new Image();
  //       img.src = URL.createObjectURL(imageToUpload);

  //       img.onload = () => {
  //         // Resize if dimensions exceed 255x255
  //         if (img.width >= 400 || img.height >= 400) {
  //           const canvas = document.createElement('canvas');
  //           const ctx = canvas.getContext('2d');

  //           // Set canvas dimensions to 255x255
  //           canvas.width = 400;
  //           canvas.height = 400;

  //           // Draw the image onto the canvas and resize
  //           ctx.drawImage(img, 0, 0, 400, 400);

  //           // Convert the canvas content back to a Blob
  //           canvas.toBlob((blob) => {
  //             const formData = new FormData();
  //             formData.append('Image', blob, imageToUpload.name);

  //             this.isLoader = true;
  //             this.loginUsersService.UploadImage(formData,'AgentLogo').subscribe((res) => {
  //               this.isLoader = false;
  //               if (!res.isError && res.status == 1) {
  //                 this.addAgentModel.AgentLogo = res.body;
  //                 this.cdr.detectChanges(); // Trigger change detection
  //               } else {
  //                 this.isLoader = false;
  //                 this.loginCommon.CallToster('E', 'Unable to upload image, Please try again later...!');
  //                 $('#agentLogo').val('');
  //               }
  //             }, (err) => {
  //               this.isLoader = false;
  //               $('#agentLogo').val('');
  //             });
  //           });
  //         } else {
  //           // No need to resize, proceed with original dimensions
  //           const formData = new FormData();
  //           formData.append('Image', imageToUpload, imageToUpload.name);

  //           this.isLoader = true;
  //           this.loginUsersService.UploadImage(formData,'AgentLogo').subscribe((res) => {
  //             this.isLoader = false;
  //             if (!res.isError && res.status == 1) {
  //               this.addAgentModel.AgentLogo = res.body;
  //               this.cdr.detectChanges(); // Trigger change detection
  //             } else {
  //               this.isLoader = false;
  //               this.loginCommon.CallToster('E', 'Unable to upload image, Please try again later...!');
  //               $('#agentLogo').val('');
  //             }
  //           }, (err) => {
  //             this.isLoader = false;
  //             $('#agentLogo').val('');
  //           });
  //         }
  //       };
  //     }
  //   } catch (error) {
  //     this.isLoader = false;
  //     this.loginCommon.CallToster('E', 'Something went wrong while uploading an image, Please try again later...!');
  //   }
  // }


  // agentPhoto_change(event: any): void {
  //   try {
  //     var ext = $('#agentPhoto').val().split('.').pop().toLowerCase();
  //     if ($.inArray(ext, ['gif', 'png', 'jpg', 'jpeg']) == -1) {
  //       this.loginCommon.CallToster('E', 'Invalid image format, Please upload image only...!');
  //       $('#agentPhoto').val('');
  //     } else {
  //       var imageToUpload = event.target.files[0];

  //       // Check image dimensions
  //       const img = new Image();
  //       img.src = URL.createObjectURL(imageToUpload);

  //       img.onload = () => {
  //         // Resize if dimensions exceed 2500x2500
  //         if (img.width >= 800 || img.height >= 600) {
  //           const canvas = document.createElement('canvas');
  //           const ctx = canvas.getContext('2d');

  //           // Set canvas dimensions to 2500x2500
  //           canvas.width = 800;
  //           canvas.height = 600;

  //           // Draw the image onto the canvas and resize
  //           ctx.drawImage(img, 0, 0, 800, 600);

  //           // Convert the canvas content back to a Blob
  //           canvas.toBlob((blob) => {
  //             const formData = new FormData();
  //             formData.append('Image', blob, imageToUpload.name);

  //             this.isLoader = true;
  //             this.loginUsersService.UploadImage(formData,'AgentPhoto').subscribe((res) => {
  //               this.isLoader = false;
  //               if (!res.isError && res.status == 1) {
  //                   this.addAgentModel.AgentPhoto = res.body;
  //                   this.cdr.detectChanges(); // Trigger change detection
  //               } else {
  //                 this.isLoader = false;
  //                 this.loginCommon.CallToster('E', 'Unable to upload image, Please try again later...!');
  //                 $('#agentPhoto').val('');
  //               }
  //             }, err => {
  //               this.isLoader = false;
  //               $('#agentPhoto').val('');
  //             });
  //           });
  //         } else {
  //           // No need to resize, proceed with original dimensions
  //           const formData = new FormData();
  //           formData.append('Image', imageToUpload, imageToUpload.name);

  //           this.isLoader = true;
  //           this.loginUsersService.UploadImage(formData,'AgentPhoto').subscribe((res) => {
  //             this.isLoader = false;
  //             if (!res.isError && res.status == 1) {

  // 	  this.addAgentModel.AgentPhoto = res.body;
  //                 this.cdr.detectChanges(); // Trigger change detection
  //         } else {
  //               this.isLoader = false;
  //               this.loginCommon.CallToster('E', 'Unable to upload image, Please try again later...!');
  //               $('#agentPhoto').val('');
  //             }
  //           }, err => {
  //             this.isLoader = false;
  //             $('#agentPhoto').val('');
  //           });
  //         }
  //       };
  //     }
  //   } catch (error) {
  //     this.isLoader = false;
  //     this.loginCommon.CallToster('E', 'Something went wrong while upload image, Please try again later...!');
  //   }
  // }



  gotoHomePage() {
    $('#ConfirmModal').modal('hide');
    setTimeout(() => {
      if (this.PortalType == 'Mobile')
        this.loginRouter.navigate(['/m']);
      else
        this.loginRouter.navigate(['/']);
    }, 1000);
  }

  doGotoLandingPage() {
    $('.modal').modal('hide');
    if (this.PortalType == 'Mobile')
      this.loginRouter.navigate(['/m']);
    else
      this.loginRouter.navigate(['/']);
  }

  OpenHelpModel() {
    $('#helpModal').modal({ backdrop: 'static', keyboard: false });
    setTimeout(() => {
      $('.modal-backdrop').css("display", "none");
    }, 500);
  }


  ResetToLogin() {
    this.userForm.controls['userName'].setValue('');
    this.userName = '';
    this.userotp = undefined;
    this.currentPinIndex = 0;
    this.enteredPin = ['', '', '', ''];
    this.isPIN = false;
    this.isOTP = false;
    this.userPIN = '';
    this.isUserPin = false;
    this.isForgotPIN = false;
    this.isLoginWithOtp = false;
  }

  // Add this method to handle webcam image capture
  // public handleImage(webcamImage: WebcamImage): void {
  //   this.webcamImage = webcamImage;
  // }

  // Add this method to handle errors during webcam initialization
  // public handleInitError(error: WebcamInitError): void {
  //   this.errors.push(error);
  // }

  // Add this method to trigger image capture from the gallery
  // public triggerFileInput(): void {
  //   this.fileInput.nativeElement.click();
  // }

  // Add this method to handle selected image from the gallery
  // public handleFileInput(event: any): void {
  //   const file = event.target.files[0];
  //   // Handle the selected file (you can use FileReader to convert it to base64 or handle it as needed)
  // }

}

